import React, { useMemo, useState } from "react";
import { Box, Flex, Icon } from "@storyofams/react-ui";
import { createClient } from "@supabase/supabase-js";
import { parse } from "date-fns";
import { defineMessages, FormattedMessage } from "react-intl";

import { PhotoProvider } from "react-photo-view";
import { Text } from "../../../../components";
import {
  ArrowDown,
  ArrowUp,
  Avatar1,
  Avatar2,
  Avatar3,
  LogoCompact,
  ThumbsUp,
} from "../../../../components/common/Icons";
import { useDate } from "../../../../hooks";
import { Stars } from "../Stars";
import { ImageModal } from "./ImageModal";
import { Media } from "./Media";
import { MediaPreview } from "./MediaPreview";

const messages = defineMessages({
  answer: "Antwoord",
  verifiedBuyer: "geverifieerde koper",
});

export const Review = ({
  author,
  avatar,
  rating,
  created_at,
  title,
  email,
  body,
  id,
  age,
  skinType,
  bodyParts,
  skinCondition,
  reply,
  imagesFileName,
  verifiedType,
  voteRating,
  publish_without_media,
  videosFileName,
}) => {
  const { formatDate } = useDate();
  const [likes, setLikes] = useState(0);
  const [image, setimage] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenAnswer, setIsOpenAnswer] = useState(false);
  const date =
    created_at?.length === 20 ? created_at : created_at?.slice(0, 19) + "Z";
  const setRating = async (vote) => {
    const supabase = createClient(
      process.env.NEXT_PUBLIC_SUPABASE_URL,
      process.env.NEXT_PUBLIC_SUPABASE_KEY
    );
    try {
      const { error } = await supabase.from("product_reviews").upsert({
        voteRating: vote + voteRating,
        id,
        email,
      });
      console.log(error);
    } catch (err) {
      console.log(err);
    }
  };
  const randomAvatar = useMemo(() => {
    const index = Math.floor(Math.random() * 3);
    switch (index) {
      case 0:
        return Avatar1;
      case 1:
        return Avatar2;
      default:
        return Avatar3;
    }
  }, []);
  return (
    <PhotoProvider>
      <Flex
        width="100%"
        border={"1px solid grey200"}
        borderRadius={"8px"}
        py={["15px", "18px"]}
        px={["15px", "25px"]}
        flexDirection={["column", "row"]}
      >
        <Flex flex={1} flexDirection={"column"} width={"100%"}>
          <Flex width={"100%"}>
            <Flex
              width={"100%"}
              flex={1}
              flexDirection={"column"}
              pr={[0, "25px"]}
              // pb={["15px", 0]}
              borderRight={["none", "1px solid grey200"]}
            >
              <Flex
                width={"100%"}
                justifyContent="space-between"
                mb={["10px", "15px"]}
              >
                <Stars stars={Number(rating)} />
                <Text color="grey600">
                  {formatDate(
                    parse(date, "yyyy-MM-dd'T'HH:mm:ss'Z'", new Date()),
                    {
                      day: "numeric",
                      month: "numeric",
                      year: "numeric",
                    }
                  )}
                </Text>
              </Flex>

              <Text
                as="h5"
                fontSize={"20px"}
                fontWeight={500}
                lineHeight={1}
                mb={"10px"}
              >
                {title === "undefined" || title === ""
                  ? body.split(" ").slice(0, 4).join(" ")
                  : title}
              </Text>
              {!body || body?.length < 150 ? (
                <Text mb={["15px", "10px"]} whiteSpace="pre-wrap">
                  {body}
                </Text>
              ) : (
                <>
                  {isOpen ? (
                    <Text whiteSpace="pre-wrap" mb={["10px", "10px"]}>
                      {body}{" "}
                      <Text
                        textDecoration={"underline"}
                        display={"inline"}
                        color="grey600"
                        cursor={"pointer"}
                        onClick={() => setIsOpen((open) => !open)}
                      >
                        lees minder
                      </Text>
                    </Text>
                  ) : (
                    <Text
                      display={"inline"}
                      whiteSpace="pre-wrap"
                      mb={["15px", "10px"]}
                    >
                      {body.slice(0, 150) + "... "}
                      <Text
                        color="grey600"
                        cursor={"pointer"}
                        display={"inline"}
                        textDecoration={"underline"}
                        onClick={() => setIsOpen((open) => !open)}
                      >
                        lees meer
                      </Text>
                    </Text>
                  )}
                </>
              )}
              <Flex
                flexWrap="wrap"
                ml={-1}
                mt={-1}
                justifyContent={["space-between", "end"]}
                alignItems={"end"}
              >
                {(imagesFileName || videosFileName) &&
                  !publish_without_media && (
                    <Media
                      images={imagesFileName || ""}
                      videos={videosFileName || ""}
                    />
                  )}
                <Flex width="100px" justifyContent="end" alignItems="center">
                  <Flex>
                    <Box
                      as="button"
                      onClick={() => {
                        if (likes === 1) {
                          setRating(0);
                          setLikes(0);
                        } else {
                          setRating(1);
                          setLikes(1);
                        }
                      }}
                      p={1}
                    >
                      <Icon
                        icon={ThumbsUp}
                        fontSize={2.5}
                        color={likes === 1 ? "oldPink" : "grey600"}
                      />
                    </Box>

                    <Text
                      minWidth={20}
                      display="flex"
                      justifyContent="center"
                      pt={0.5}
                    >
                      {voteRating + likes}
                    </Text>

                    <Box
                      as="button"
                      onClick={() => {
                        if (likes === -1) {
                          setRating(0);
                          setLikes(0);
                        } else {
                          setRating(-1);
                          setLikes(-1);
                        }
                      }}
                      p={1}
                      pr={0}
                    >
                      <Icon
                        icon={ThumbsUp}
                        css={{ transform: "rotate(180deg)" }}
                        fontSize={2.5}
                        color={likes === -1 ? "oldPink" : "grey600"}
                      />
                    </Box>
                  </Flex>
                </Flex>
              </Flex>
            </Flex>
            {(imagesFileName || videosFileName) && !publish_without_media && (
              <MediaPreview
                images={imagesFileName || ""}
                videos={videosFileName || ""}
              />
            )}
          </Flex>
          {!!reply && (
            <Box
              // maxWidth={"690px"}
              py={"10px"}
              mr={[0, 1]}
              px={["15px", "20px"]}
              bg="#F4F3F0"
              mt={["15px", "20px"]}
              borderRadius={"6px"}
            >
              <Flex
                cursor={"pointer"}
                onClick={() => setIsOpenAnswer((open) => !open)}
                width={"100%"}
                flexDirection={"column"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Flex alignItems={"center"}>
                  <Text fontWeight={500} fontSize={"16px"} mr="8px">
                    Reactie van Natural Heroes
                  </Text>
                  <Icon
                    icon={isOpenAnswer ? ArrowUp : ArrowDown}
                    pt={"3px"}
                    fontSize={"12px"}
                  ></Icon>
                </Flex>
              </Flex>
              {isOpenAnswer && (
                <>
                  <Flex justifySelf={"flex-start"} mt={["15px", "0"]}>
                    <Box
                      bg="white"
                      width={"28px"}
                      height={"28px"}
                      borderRadius={"full"}
                      pt={"1px"}
                      pl={"3px"}
                      mr="8px"
                    >
                      <Icon icon={LogoCompact} fontSize={"23px"} />
                    </Box>
                    <Text fontWeight={500} fontSize="16px">
                      Natural Heroes
                    </Text>
                  </Flex>
                  <Text mt={"15px"}>{reply}</Text>
                </>
              )}
            </Box>
          )}
        </Flex>

        <Box
          borderTop={["1px solid grey200", "none"]}
          pl={[0, "25px"]}
          mt={[2, 0]}
          pt={[2, 0]}
          flex={0.4}
          borderLeft={["none", "1px solid grey200"]}
        >
          <Flex width={"100%"} mb="10px">
            <Icon fontSize={"30px"} icon={randomAvatar}></Icon>

            <Text fontWeight={500} fontSize={"16px"} ml={"8px"} mr="15px">
              {author}
            </Text>
            {verifiedType === 2 && (
              <Box
                ml={[0, 2]}
                px={1}
                mt="3px"
                pt={"2px"}
                border="1px solid greenish"
                borderRadius="full"
                height={20}
              >
                <Text
                  fontSize={"12px"}
                  fontWeight={600}
                  color="greenish"
                  lineHeight={1}
                  css={{ textTransform: "uppercase" }}
                >
                  <FormattedMessage {...messages.verifiedBuyer} />
                </Text>
              </Box>
            )}
          </Flex>
          {age && (
            <Flex fontSize={"15px"}>
              <Text width="35%" fontWeight={500}>
                Leeftijd
              </Text>
              <Text>{age}</Text>
            </Flex>
          )}
          {skinType && (
            <Flex fontSize={"15px"}>
              <Text width="35%" fontWeight={500}>
                Huidtype
              </Text>
              <Flex flex={1} flexWrap={"wrap"}>
                {skinType.split(",").map((text, i, arr) => (
                  <Text mr={"5px"} key={i}>
                    {i === arr.length - 1 ? text : text + ","}
                  </Text>
                ))}
              </Flex>
            </Flex>
          )}
          {skinCondition && (
            <Flex fontSize={"15px"}>
              <Text width="35%" fontWeight={500}>
                Gebruiksdoel
              </Text>
              <Flex flex={1} flexWrap={"wrap"}>
                {skinCondition.split(",").map((text, i, arr) => (
                  <Text mr={"5px"} key={i}>
                    {i === arr.length - 1 ? text : text + ","}
                  </Text>
                ))}
              </Flex>
            </Flex>
          )}
          {bodyParts && (
            <Flex fontSize={"15px"}>
              <Text width="35%" fontWeight={500}>
                Lichaamsdeel
              </Text>
              <Flex flex={1} flexWrap={"wrap"}>
                {bodyParts.split(",").map((text, i, arr) => (
                  <Text mr={"5px"} key={i}>
                    {i === arr.length - 1 ? text : text + ","}
                  </Text>
                ))}
              </Flex>
            </Flex>
          )}
        </Box>
      </Flex>

      <ImageModal image={image} isOpen={!!image} close={() => setimage(null)} />
    </PhotoProvider>
  );
};
